import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import DateInputwithcal from '../ui/DateInputwithcal';
import { SearchBar } from '../SearchBox/SearchBar';
import { GetMasterRegion } 
  from "@/redux/Masters/countryclause/actions";
import { motion, AnimatePresence } from 'framer-motion';
import { Save, X } from 'lucide-react';
import CelebrationButton from '../ui/CelebrationButton/CelebrationButton';

const CountryModal = ({  open, onClose, formData, errors, handleInputChange,handleDateError,handleDateChange, onSave,editData  }) => {


const dispatch = useDispatch();

  // ✅ DATA from reducer
const { 
    countryclauseRegionList = [] 
} = useSelector(state => state.countryClause);
  const { isAnimate } = useSelector((state) => state.toast);

  useEffect(() => {
    if(!open) return;
    dispatch(GetMasterRegion());
  }, [open,dispatch]);

  if (!open) return null;

  


  return (

 <AnimatePresence>
        { (
          <div className="fixed inset-0 z-50 flex items-center justify-center">
            <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              className="relative bg-white dark:bg-slate-800 rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden"
              data-testid="location-modal"
            >
              {/* Modal Header */}
              <div className="bg-gradient-to-r from-emerald-600 to-emerald-700 px-6 py-4 flex items-center justify-between">
                <h2 className="text-xl font-bold text-white">
                  {  ' Add/Modify Country Clause Info'}
                </h2>
                <button onClick={onClose} className="p-1 hover:bg-white/10 rounded-lg transition-colors">
                  <X className="w-5 h-5 text-white" />
                </button>
              </div>

              {/* Modal Body */}
<div className="p-4 space-y-3 bg-white dark:bg-slate-900 rounded-lg border border-slate-200 dark:border-slate-800">

        {/* Region */}
        <div className="grid grid-cols-12 gap-2 items-center">
          <label className="col-span-3 text-xs font-medium">
            Region<span className="text-red-500">*</span>
          </label>
          <div className="col-span-9">
            <select className={`w-full px-3 py-2.5 bg-slate-50 dark:bg-slate-700 border rounded-lg text-sm text-slate-800 dark:text-white focus:outline-none focus:ring-2 focus:ring-emerald-500/20 ${errors.countryClauseId ? 'border-red-500' : 'border-slate-200 dark:border-slate-600'}`} name="countryClauseId" value={formData?.countryClauseId || ""}  onChange={handleInputChange}>
              {/* <option>SELECT Commodity Group</option> */}
              <option>select</option>
                {
                    countryclauseRegionList?.map((group, key) => (
                        <option key={group.countryClauseId} value={group.countryClauseId}>{group.countryClauseType}</option>
                    ))
                }
            </select>
            {errors.countryClauseId && (
    <p className="text-red-500 text-xs mt-1">{errors.countryClauseId}</p>
  )}
          </div>
        </div>


        {/* Country Name   */}
        <div className="grid grid-cols-12 gap-2 items-center">
          <label className="col-span-3 text-xs font-medium">
            Country Name<span className="text-red-500">*</span>  
          </label>
          <div className="col-span-9">
            <Input name="country" value={formData.country} onChange={handleInputChange} className={`w-full px-3 py-2.5 bg-slate-50 dark:bg-slate-700 border rounded-lg text-sm text-slate-800 dark:text-white focus:outline-none focus:ring-2 focus:ring-emerald-500/20 ${errors.country ? 'border-red-500' : 'border-slate-200 dark:border-slate-600'}`}/>
            {errors.country && (
    <p className="text-red-500 text-xs mt-1">{errors.country}</p>
  )}
          </div>
        </div>

         {/* Country ISO Code   */}
        <div className="grid grid-cols-12 gap-2 items-center">
          <label className="col-span-3 text-xs font-medium">
            Country ISO Code  <span className="text-red-500">*</span>
          </label>
          <div className="col-span-9">
  <Input
    name="countryCode"
    value={formData.countryCode}
    onChange={handleInputChange}
    className={`w-full px-3 py-2.5 bg-slate-50 dark:bg-slate-700 border rounded-lg text-sm text-slate-800 dark:text-white focus:outline-none focus:ring-2 focus:ring-emerald-500/20 ${errors.countryCode ? 'border-red-500' : 'border-slate-200 dark:border-slate-600'}`}
  />
  {errors.countryCode && (
    <p className="text-red-500 text-xs mt-1">{errors.countryCode}</p>
  )}
</div>

        </div>

         {/* Country Clause */}
        <div className="grid grid-cols-12 gap-2 items-center">
          <label className="col-span-3 text-xs font-medium">
            Country Clause 
          </label>
          <div className="col-span-9">
            <Textarea name="countryClause" value={formData.countryClause} onChange={handleInputChange} className={`w-full px-3 py-2.5 bg-slate-50 dark:bg-slate-700 border rounded-lg text-sm text-slate-800 dark:text-white focus:outline-none focus:ring-2 focus:ring-emerald-500/20 border-slate-200 dark:border-slate-600`}/>
          </div>
        </div>
              

               <div className="grid grid-cols-12 gap-2 items-center">
          <label className="col-span-3 text-xs font-medium">
            <span className="text-red-500">Display Country Warning.</span>
          </label>
           <div className="col-span-1">
            <Input
    type="checkbox"
    name="countryWarning"
    checked={formData.countryWarning}
    onChange={handleInputChange}
    className="scale-175 origin-left cursor-pointer"
/>

          </div>
          
        </div>
       
    

      </div>
              {/* Modal Footer */}
              <div className="px-6 py-4 bg-slate-50 dark:bg-slate-800/50 border-t border-slate-200 dark:border-slate-700 flex items-center justify-end gap-3">
                <button
                  onClick={onClose}
                  className="px-4 py-2 text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-lg font-medium transition-colors"
                >
                  Cancel
                </button>
                  <CelebrationButton
              onClick={() => onSave()}
              label={"Save"}
                          className="flex items-center gap-2 px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg font-medium transition-colors"
              icon={<Save className="w-4 h-4" />}
              isSuccess={isAnimate}
             
           />
              </div>
            </motion.div>
          </div>
        )}
      </AnimatePresence>


);
};

export default CountryModal;
